import {
  AvTimer as AvTimerIcon,
  LocalShipping as LocalShippingIcon,
  Menu as MenuIcon,
  Place as PlaceIcon,
} from '@mui/icons-material';
import MonetizationOn from '@mui/icons-material/MonetizationOn';

export const MENU = 'menu';

export const tabs = [
  {
    id: MENU,
    value: MENU,
    icon: MenuIcon,
    type: 'action',
    dataTestId: 'openMenuBtn',
  },
  {
    id: 1,
    value: '/map',
    icon: PlaceIcon,
    type: 'link',
    dataTestId: 'openMapBtn',
  },
  {
    id: 2,
    value: '/deliveries',
    icon: LocalShippingIcon,
    type: 'link',
    dataTestId: 'openDeliveriesBtn',
  },
  {
    id: 4,
    value: '/finance',
    icon: MonetizationOn,
    type: 'link',
  },
  {
    id: 3,
    value: '/organizer_new/tasks?tag=new_tasks&period_alias=previousMonth',
    icon: AvTimerIcon,
    type: 'link',
    dataTestId: 'openTasksBtn',
    badgeColor: 'primary',
  },
];
